import * as React from 'react';

const Refund24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.28 4.28a.75.75 0 0 0-1.06-1.06l-4 4a.75.75 0 0 0 0 1.06l4 4a.75.75 0 0 0 1.06-1.06L4.56 8.5h10.658c2.865 0 5.282 2.27 5.282 5.5s-2.417 5.5-5.282 5.5H4.75a.75.75 0 0 0 0 1.5h10.468C19.015 21 22 17.95 22 14s-2.985-7-6.782-7H4.56z"
  }
));
Refund24.Size = 24;
Refund24.Title = "Refund";

export { Refund24 as default };
